import React, { useEffect, useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import { trackPromise } from 'react-promise-tracker';
import {
    DISABLE_DYNAMIC_FIELDS,
    fetchDynamicFields,
    isAllDynamicFieldsEmpty,
    FIELD_TYPES,
} from '../utils/utils';
import '../TaskDynamicFields.scss';

function formatFieldData(field) {
    if (!field.Data) return 'N/A';

    switch (field.FieldType) {
        case FIELD_TYPES.date: {
            const date = new Date(field.Data);
            const DD = date.getDate().toString().padStart(2, '0');
            const MM = (date.getMonth() + 1).toString().padStart(2, '0');
            const YYYY = date.getFullYear().toString().padStart(4, '0');
            return `${DD}/${MM}/${YYYY}`;
        }
        case FIELD_TYPES.multiText:
            return <pre>{field.Data}</pre>;
        default:
            return field.Data;
    }
}

// Required props:
// {
//      projectTypeId: Integer
//      taskTypeId: Integer
//      objectId: Integer; id of current comment
//      sidePanelStyles: boolean
// }
const TasksDynamicFieldsContent = (props) => {
    const { projectTypeId, taskTypeId, objectId, sidePanelStyles } = props;
    const [dynamicFields, setDynamicFields] = useState([]);

    useEffect(() => {
        if (objectId == null || DISABLE_DYNAMIC_FIELDS) return;
        trackPromise(
            fetchDynamicFields({ projectTypeId, taskTypeId, objectId })
                .then(setDynamicFields)
                .catch((error) => {
                    setDynamicFields([]);
                    console.log(error);
                }),
            'tasks-comments-panel'
        );
    }, [projectTypeId, taskTypeId, objectId]);

    if (
        dynamicFields.length === 0 ||
        isAllDynamicFieldsEmpty(dynamicFields) ||
        DISABLE_DYNAMIC_FIELDS
    ) {
        return null;
    }

    return (
        <div className="tasks-dynamic-fields-modal-content-wrapper">
            {dynamicFields.map((field, idx) => (
                <div className={`comment-files-row${sidePanelStyles ? ' p-0' : ''}`} key={idx}>
                    <ListGroup.Item className="multiple-files-row comment-files left-aligned">
                        <div className={`dynamic-field-label`}>
                            {field.Label}
                            <span className="red">{field.Required ? ' *' : null}</span>
                        </div>
                        <div className="dynamic-field-mask-label">
                            {field.FieldMask && field.Data ? field.FieldMask : null}
                        </div>
                        <div className="pb-3">{formatFieldData(field)}</div>
                    </ListGroup.Item>
                </div>
            ))}
            <div className={`pb-1`}></div>
        </div>
    );
};

export default TasksDynamicFieldsContent;
